import styled from 'styled-components';

export const GuestReviewTemplatesContainer = styled.section`
  margin-bottom: 40px;
`;
